import type { DeliveryGroupDraft } from './deliveryGroupTypes';
import {
  getLegacyBucketOrderedUids,
  getPositionOrderedUids
} from './editorStopOrdering';
import { isSequentialStopsEditorShadowDebugEnabled } from './sequentialStopsEditorFlags';

export type EditorOrderShadowDiff = {
  legacyBucketUids: string[];
  positionOrderUids: string[];
  uidOrderMismatch: boolean;
  positionByUid: Record<string, number | undefined>;
  legacyPositionByUid: Record<string, number | undefined>;
};

export function buildEditorOrderShadowDiff(
  groups: DeliveryGroupDraft[]
): EditorOrderShadowDiff {
  const legacyBucketUids = getLegacyBucketOrderedUids(groups);
  const positionOrderUids = getPositionOrderedUids(groups);
  const positionByUid: Record<string, number | undefined> = {};
  for (const g of groups) {
    for (const s of [...g.loadingStops, ...g.unloadingStops]) {
      positionByUid[s.uid] = s.position;
    }
  }
  return {
    legacyBucketUids,
    positionOrderUids,
    uidOrderMismatch: legacyBucketUids.join('|') !== positionOrderUids.join('|'),
    positionByUid,
    legacyPositionByUid: positionByUid
  };
}

export function logEditorOrderShadowDiff(
  groups: DeliveryGroupDraft[],
  context?: string
): void {
  if (!isSequentialStopsEditorShadowDebugEnabled()) return;
  const diff = buildEditorOrderShadowDiff(groups);
  if (!diff.uidOrderMismatch) return;
  // eslint-disable-next-line no-console
  console.debug('[SequentialStopsEditorShadow]', context ?? 'editor', {
    legacyBucketUids: diff.legacyBucketUids,
    positionOrderUids: diff.positionOrderUids,
    positionByUid: diff.positionByUid
  });
}
